import React from 'react';

const LoadingOverlay = ({ open, message = 'Loading...' }) => {
  if (!open) return null;

  return (
    <div className="spinner-overlay">
      <div className="spinner-container">
        <div 
          className="spinner-border text-primary mb-3" 
          role="status" 
          style={{ width: '60px', height: '60px' }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
        <h6 className="text-primary fw-semibold">{message}</h6>
      </div>
    </div>
  );
};

export default LoadingOverlay;
